import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminVerify } from '../utils/adminSession';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkAuth = useCallback(async () => {
    try {
      const response = await adminVerify();
      setIsAuthenticated(response.data.valid);
    } catch {
      setIsAuthenticated(false);
    } finally {
      setIsChecking(false);
    }
  }, [adminVerify]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center" data-testid="protected-route-loading">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" data-testid="protected-route-spinner"></div>
          <p className="text-gray-600" data-testid="protected-route-loading-text">Verificando acesso...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={redirectState} replace />;
  }

  return children;
};

export default ProtectedRoute;
